import React, { Component } from 'react';
import {
  DragDropContext,
  Droppable,
  Draggable,
} from 'react-beautiful-dnd';

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  padding: '8px 16px',
  margin: '0 0 8px 0',
  background: '',
  boxShadow: isDragging ? '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)' : '',
  ...draggableStyle,
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? '' : '',
  padding: '8px',
  width: 'auto',
});

class DnDList extends Component {
  render() {
    return (
      <DragDropContext onDragEnd={this.props.onDragEnd} onBeforeDragStart={this.props.onBeforeDragStart}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div className="dragging-item-wrap"
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {this.props.children.map((item, index) => (
                <Draggable key={item.props.id} draggableId={item.props.id} index={index}>
                  {(provided, snapshot) => (
                    <div className="dragging-item"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}
                    >
                      {item}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}

export default DnDList;
